import { Address } from './addresses';

export type UserId = number;

export enum Domicile {
  NONE = 'NONE',
  US_CITIZEN = 'US_CITIZEN',
  US_RESIDENT = 'US_RESIDENT',
  NON_RESIDENT = 'NON_RESIDENT',
}

export enum PlannedInvestmentAmount {
  R100_2000 = 'R100_2000',
  R2000_5000 = 'R2000_5000',
  R5000_25000 = 'R5000_25000',
  R25000_100000 = 'R25000_100000',
  R100000_OR_MORE = 'R100000_OR_MORE',
}

export interface User {
  id: UserId;
  email: string;
  auth0UserId: string;
  firstName?: string;
  lastName?: string;
  domicile?: Domicile;
  profilePictureUrl?: string;
  primaryResidenceAddress?: Address;
  mailingAddress?: Address;
  phoneNumber?: string;
  plannedInvestmentAmount?: PlannedInvestmentAmount;
  birthDate?: string;
  createdAt: string;
  updatedAt?: string;
  accreditedInvestor: boolean;
  tosAgreed: boolean;
  privacyAgreed: boolean;
  admin: boolean;
  active: boolean;
}

export interface UserRequest extends Partial<User> {
  id: UserId;
}

export interface UserEmailChangeRequest {
  id: UserId;
  newEmail: string;
}

export interface UserQueryParams {
  sort?: UserQuerySort;
  /**
   * a general search query that spans the following fields:
   *
   * id         | exact match
   * email      | match if starts with query
   * first name | match if starts with query
   * last name  | match if starts with query
   */
  q?: string;

  /**
   * page | [1, max page]
   * size | > 0
   */
  page?: number;
  size?: number;
}

export const USER_SORT_ID_ASC = 'id:asc';
export const USER_SORT_ID_DESC = 'id:desc';
export type UserQuerySort = typeof USER_SORT_ID_ASC | typeof USER_SORT_ID_DESC;

export const UserTradesStatus = {
  NO_TRADES: 'NO_TRADES',
  PENDING_TRADES: 'PENDING_TRADES',
  ONLY_SETTLED_TRADES: 'ONLY_SETTLED_TRADES',
} as const;
export type UserTradesStatus = (typeof UserTradesStatus)[keyof typeof UserTradesStatus];
